import { useQuery } from '@tanstack/react-query';
import {
  fetchCumulativeAnalysis,
  fetchCumulativeAnalysisByCategory,
  type GraphCategory,
  type GraphFilters,
} from '../services/graphApi';

export function useCumulativeAnalysisQuery(
  eventId: number | null,
  category: GraphCategory | null,
  refreshIntervalMs = 0,
  enabled = true,
  filters?: GraphFilters
) {
  return useQuery({
    queryKey: ['cumulative-analysis', eventId, category?.id ?? null, filters],
    queryFn: async () => {
      if (category) {
        const charts = await fetchCumulativeAnalysisByCategory(eventId ?? 0, category, filters);

        return { charts };
      }

      return fetchCumulativeAnalysis(eventId ?? 0, filters);
    },
    enabled: enabled && eventId != null,
    refetchInterval: refreshIntervalMs > 0 ? refreshIntervalMs : false,
  });
}
